import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';

export const managementAnalysisFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'ManagementAnalysisDetails/filterSelections',
  default: {
    availableFilters: [],
    selectedFilters: [],
    appliedFilters: [],
  },
});
